import { Button } from '@ipfabric/ui-components/Button/Button';
import type { TabData } from 'components/DeviceView/deviceViewTypes';
import { useLocale } from 'containers/App/LocaleContext';
import type { DeviceDetailData } from 'containers/HostnameDetail/HostnameDetailContent';
import { Permissions } from 'containers/Permissions/Permissions';
import { type FC, memo } from 'react';
import { protocolsWithExistingLogs } from 'utils/constants';
import { useDownloadCliLog } from 'utils/hooks/useDownloadCliLog';
import { isDeviceDetailData } from '../helpers/isDeviceDetailData';

interface Props {
  tabData: TabData;
}

export const isDownloadAvailable = (device: DeviceDetailData): boolean =>
  !!device.taskKey &&
  !!device.loginType &&
  protocolsWithExistingLogs.includes(device.loginType.toLowerCase());

const BareDeviceViewContentCliLogButton: FC<Props> = (props) => {
  const { loading, downloadLog } = useDownloadCliLog({
    collection: 'task',
    // '' is not valid taskKey, but this default value will not be used because if tabData is not set,
    // the button will not be rendered
    dataKey: props.tabData?.device?.taskKey ?? '',
    fileName: `${props.tabData?.device?.sn}_${props.tabData?.device?.taskKey}`,
  });
  const msg = useLocale();
  if (!props.tabData) {
    return null;
  }
  const {
    tabData: { device },
  } = props;

  if (isDeviceDetailData(device) && isDownloadAvailable(device)) {
    return (
      <Permissions requiredScope={['settings']}>
        <Button
          renderAs='button'
          onClick={downloadLog}
          icon='fa-file-lines'
          size='small'
          variant='plain'
          loading={loading === 'LOADING'}
        >
          {msg.deviceView.btnShowLog}
        </Button>
      </Permissions>
    );
  }
  return null;
};

export const DeviceViewContentCliLogButton = memo(
  BareDeviceViewContentCliLogButton,
);
